import React from 'react';
import { compose } from 'redux';
import PropType from 'prop-types';
import { withStyles } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import DoneIcon from '@material-ui/icons/Done';
import { fade } from '@material-ui/core/styles/colorManipulator';
import { frenchPink } from 'themes/colors';

const getStatusStyling = (props, theme) => {
  if (props.active) {
    return {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.white,
      border: 'none',
    };
  }
  if (props.completed) {
    return {
      backgroundColor: fade(theme.palette.primary.main, 0.2),
      color: theme.palette.primary.main,
      border: 'none',
    };
  }
  if (props.skipped && !props.active) {
    return {
      backgroundColor: fade(frenchPink, 0.2),
      color: frenchPink,
    };
  }
  return {};
};

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.white,
    zIndex: 1,
    color: theme.palette.gray.text,
    width: '2.5rem',
    height: '2.5rem',
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${theme.palette.secondary[100]}`,
  },
  status: props => getStatusStyling(props, theme),
});

const getIcon = (completed, skipped, active, icon) => {
  if (completed) {
    return <DoneIcon />;
  }
  if (skipped && !active) {
    return <ClearIcon />;
  }
  return icon;
};

const StepIcon = ({
  classes,
  icon,
  active,
  completed,
  skipped,
}) => (
  <div
    className={`${classes.root} ${classes.status}`}
  >
    {getIcon(completed, skipped, active, icon)}
  </div>
);

StepIcon.propTypes = {
  classes: PropType.shape({}).isRequired,
  icon: PropType.string.isRequired,
  active: PropType.bool.isRequired,
  completed: PropType.bool.isRequired,
  skipped: PropType.bool.isRequired,
};

export default compose(withStyles(styles))(StepIcon);
